import * as React from 'react';
import * as ReactDom from 'react-dom';
import * as d3 from 'd3';
import './InclinationChart.css';

interface InclinationChartProps {
    value: number;
    allowToggle: boolean;
    onToggle?: Function;
    initialClickedState?: boolean;
}

export class InclinationChart extends React.Component<InclinationChartProps, { clicked: boolean, value: number }> {
    private inclinationRect: d3.Selection<Element | d3.EnterElement | Document | Window | null, {}, null, undefined>;
    private inclinationText: d3.Selection<Element | d3.EnterElement | Document | Window | null, {}, null, undefined>;

    // minimum values so the inital load doesn't look weird
    private minimumTextOffset = 10;
    private minimumRectWidth = 18;
    private initialInclinationColor = '#00223e';
    private clickedColor = '#f00000';

    private svgContainer: any = undefined;
    private element: any = undefined;

    constructor(props: InclinationChartProps) {
        super(props);
        this.state = {
            clicked: this.props.initialClickedState === true,
            value: this.props.value
        };
    }

    componentDidMount() {
        this.buildInclinationChart();
        this.updateInclinationChart(this.props.value);
        this.redraw.bind(this);
        window.addEventListener('resize', this.redraw.bind(this));
        window.addEventListener('side-menu-toggle', this.redraw.bind(this));
    }

    componentWillReceiveProps(nextProps: InclinationChartProps) {
        this.setState({
            value: nextProps.value
        },            () => {
            this.updateInclinationChart(nextProps.value);
        });
    }
    
    redraw() {
        setTimeout(
            () => {
                this.svgContainer
                    .attr('width', this.element.clientWidth)
                    .attr('height', this.element.clientHeight);

                this.updateInclinationChart(this.props.value);
                this.forceUpdate();
            },
            100);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.redraw.bind(this));
        window.removeEventListener('side-menu-toggle', this.redraw.bind(this));
    }

    buildInclinationChart() {
        this.element = ReactDom.findDOMNode(this);

        this.svgContainer = d3.select(this.element).append('svg')
            .attr('width', this.element.clientWidth)
            .attr('height', this.element.clientHeight);

        // inclination value rectangle
        const inclinationGroup = this.svgContainer.append('g');

        this.inclinationRect = inclinationGroup
            .append('rect')
            .attr('rx', 3)
            .attr('ry', 3)
            .attr('x', 0)
            .attr('y', 4)
            .attr('width', this.minimumRectWidth)
            .attr('height', 16)
            .attr('fill', this.initialInclinationColor);

        this.inclinationText = inclinationGroup
            .append('text')
            .text('0%')
            .attr('x', this.minimumRectWidth - this.minimumTextOffset)
            .attr('y', 16)
            .attr('font-size', '12')
            .attr('font-weight', 'bold')
            .attr('font-family', 'Open Sans')
            .attr('fill', 'white');
    }

    updateInclinationChart(inclinationValue: number, fast?: boolean) {
        // const element = ReactDom.findDOMNode(this);

        if (inclinationValue > 99) {
            inclinationValue = 99;
        }

        if (inclinationValue < 0) {
            inclinationValue = 0;
        }

        // inclination value rectangle
        let inclinationFill =  '#00223e';
        if (this.state.clicked) {
            inclinationFill = this.clickedColor;
        }
        // if (inclinationValue <= 25) {
        //     inclinationFill = this.initialInclinationColor;
        // } else if (inclinationValue <= 75) {
        //     inclinationFill = '#6c30f5';
        // } else {
        //     inclinationFill = '#b8271c';
        // }

        let textOffset;
        if (inclinationValue <= 9) {
            textOffset = this.minimumTextOffset;
        } else if (inclinationValue < 100) {
            textOffset = 18;
        } else {
            textOffset = 25.5;
        }

        let inclinationRectWidth = this.element.clientWidth * (inclinationValue / 100);

        if (inclinationRectWidth < this.minimumRectWidth) {
            inclinationRectWidth = this.minimumRectWidth;
        }

        this.inclinationRect.transition().duration(fast ? 250 : 2000)
            .attr('width', inclinationRectWidth)
            .attr('fill', inclinationFill);

        this.inclinationText
            .transition().duration(fast ? 250 : 2000)
            .tween('text', (d) => {
                const currentValue = Number(this.inclinationText.text().replace('%', ''));
                const interpolator = d3.interpolateNumber(currentValue, inclinationValue);

                return (t) => {
                    this.inclinationText.text(`${Math.round(interpolator(t))}`);
                };
            })
            .attr('x', inclinationRectWidth - textOffset);
    }

    clicked() {
        if (this.props.onToggle) {
            this.props.onToggle();
        }
        this.setState(
            {
                clicked: !this.state.clicked
            },
            () => {
                this.updateInclinationChart(this.state.value, true);
            });
    }

    render() {
        return <div className="inclination-chart" onClick={(e) => this.props.allowToggle && this.clicked()} />;
    }
}


// WEBPACK FOOTER //
// ./src/components/charts/InclinationChart.tsx